
export class MSISDNValidation
{
    static validateCCMsisdn(countryCode: string, msisdn: string): string
    {
        // if(countryCode.startsWith("+"))
        // {
        //     countryCode = countryCode.slice(1);
        // }

        // return countryCode + msisdn;

        return msisdn;
    }

    static validateLengthMsisdn(msisdn: string, numberMinLength: string, numberMaxLength: string): boolean
    {
        return msisdn.length < +numberMinLength || msisdn.length > +numberMaxLength ?  false : true;
    }

}
//     static validateMSISDN( countryCode:string,msisdn:string, numberMaxLength:string, numberMinLength:string)
//     {

//         var maxLength :number = +numberMaxLength;
//         var minLength : number = +numberMinLength;
//         if(msisdn.length <= maxLength && msisdn.length >= minLength)
//         {
                
//                     if(msisdn.startsWith('0') && countryCode.startsWith('+'))
//                     {
//                         // console.log("Check replace =====",msisdn.replace('0',''));
//                         var msisdnNumber = msisdn.slice(1);
//                         var countrycode = countryCode.slice(1);
//                         // console.log("MSISDN NUMBER =======",msisdnString);
//                         if((countrycode+msisdnNumber).length === 12)
//                         {
//                             return true;
//                         }
//                         return false;
//                     }
//                     else if((msisdn+countryCode).length === 12)
//                     {
//                             return true;
//                     }
//                     return false;
                
//                 }
//              console.log("length issue");
//              return false;
//         }
       
// }

// the msisdn length including cc is 12

// eg

// 249912391302

// without +

// so for length u can validate 12 after omiting the zero (249*0*9xx) 






// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/msisdnvalidation/msisdnvalidation.tsx